var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyjobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "gnav-header-1i89ga9 eac13zx0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 20.787a.5.5 0 00.668 0l1.116-1C18.6 15.21 22 12.188 22 8.486c0-3.022-2.425-5.4-5.5-5.4-1.738 0-3.412 1.311-4.5 2.571-1.088-1.26-2.762-2.571-4.5-2.571-3.075 0-5.5 2.378-5.5 5.4 0 3.702 3.4 6.724 8.55 11.314 0-.009.688.604 1.116.987z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyjobs);
export default __webpack_public_path__ + "static/media/myjobs.1e1da5e341896db8e4ba6ad0cd4b1aae.svg";
export { ForwardRef as ReactComponent };